export const HAVE_US_CALL_YOU_META_DATA = "Get in touch with a venue expert"
export const DO_YOU_NEED_ASSISTANCE_CALL = "+91 827-922-0676"
export const PHOTOGRAPHER_LANDING_PAGE = "Get in touch with a expert"